<template>
    <div class="content-pc">
        <div class="title mg-title" v-if="recentListingTitle" v-html="recentListingTitle"></div>
        <rencentListingsPc />
    </div>
</template>

<script>
import rencentListingsPc from '../recent-listings/pc';
export default {
    name: 'content-pc',
    components: {
        rencentListingsPc: rencentListingsPc
    },
    props: {
        recentListingTitle: {
            required: true,
            type: String
        }
    }
};
</script>
